/* shto-press: on desktop the logos spread across the row; when they don't fit (a narrow desktop, or more logos added in
   the editor) the band is marked data-shto-press-overflow and moves like on phones (CSS). The band also pauses while it is
   off screen. Runs after the page shows (defer); nothing waits for it. */
(function () {
  if (window.ShtoPress) return;
  window.ShtoPress = true;
  var MIN_GAP = 24;

  function check(root) {
    var band = root.querySelector('.shto-press__band');
    var list = root.querySelector('.shto-press__logos');
    if (!band || !list) return;
    var items = list.children, sum = 0;
    for (var i = 0; i < items.length; i++) sum += items[i].getBoundingClientRect().width;
    var need = sum + MIN_GAP * Math.max(0, items.length - 1);
    // The marked state lays the logos out differently, so measure the band's own width, not the list's.
    root.toggleAttribute('data-shto-press-overflow', need > band.clientWidth + 0.5);
  }

  function init(root) {
    if (root.shtoPress) return;
    root.shtoPress = true;
    var run = function () { check(root); };
    run();
    root.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', run, { once: true }); });
    if ('ResizeObserver' in window) new ResizeObserver(run).observe(root);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { root.toggleAttribute('data-shto-press-offscreen', !e.isIntersecting); });
      }).observe(root);
    }
  }

  function initAll(scope) { (scope || document).querySelectorAll('.shto-press').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
